import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class AskBackofficeAssistantResponse extends SuccessfulApiResponse {
    answer() {
        return this.content().answer;
    }
}
